import { render, staticRenderFns } from "./iGridView.vue?vue&type=template&id=5b7cb989&scoped=true&"
import script from "./iGridView.vue?vue&type=script&lang=js&"
export * from "./iGridView.vue?vue&type=script&lang=js&"
import style0 from "./iGridView.vue?vue&type=style&index=0&id=5b7cb989&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7cb989",
  null
  
)

export default component.exports